import { DropdownSelectionInput } from '@adornis/formfield/fields/dropdown-selection-input.js';
import type { FunctionalFormFieldProps } from '@adornis/formfield/functional-form-field.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { OrganizationsAPI } from '@saraa/organizations/api/OrganizationsAPI.js';

/**
 * Picks an organization by id.
 *
 * The option list is *not* filtered here — `getMyOrganizations` already answers
 * with what the caller may see (everything for a platform admin, the ones they
 * belong to otherwise), so filtering again on the client would only be able to
 * make it wrong.
 *
 * A dropdown over the full list rather than a search picker: organizations are
 * few, and it keeps the form value a plain id string.
 */
export const OrganizationSelect = (props: Partial<FunctionalFormFieldProps<string>> & { placeholder?: string }) => {
  const organizationsQuery = useQuery(() => OrganizationsAPI.getMine()({ _id: 1, name: 1 }), []);
  const organizations = organizationsQuery.value ?? [];
  const nameById = new Map(
    organizations.map(organization => [organization._id, organization.name ?? organization._id]),
  );

  return DropdownSelectionInput<string>({
    ...props,
    selectables: organizations.map(organization => organization._id),
    renderString: id => nameById.get(id) ?? id,
    placeholder: props.placeholder ?? 'Pick an organization',
    emptyState: organizationsQuery.loading ? 'Loading…' : 'No organizations available',
  });
};
